import React, { useState } from 'react';
import { Box } from '@mui/material';
import Departamentos from './Departamentos';
import Fundamentos from './Fundamentos';
import { CustomTabs, CustomTab } from '../components/CustomTabs';

const Diretrizes: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ margin: 'auto' }}>
      <CustomTabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        variant="fullWidth"
      >
        <CustomTab tabTitle="Fundamentos" content={<Fundamentos />} />
        <CustomTab tabTitle="Departamentos" content={<Departamentos />} />
      </CustomTabs>
    </Box>
  );
};

export default Diretrizes;